import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Button, Illustration } from '@node-space/ui-components'

interface RefundConfirmationProps {
  handleClose: () => void
}

export const RefundComplete = ({ handleClose }: RefundConfirmationProps) => {
  const { t } = useTranslation()

  const headline = t('approvals.sentForApprovalDisclaimer')

  const description = t('wallets.fiatSend.requiresApprovalDescription')

  return (
    <Box
      flex
      flexCol
      justify="center"
      align="center"
      className="max-w-[500px] gap-5 text-center"
      data-testId="complete-success"
    >
      <Illustration name="HourGlassLow" color="info" />
      <h2 className="text-foreground-prominent text-h2">{headline}</h2>
      <p className="text-foreground-prominent text-body-regular">{description}</p>
      <Button onClick={handleClose}>{t('wallets.fiatSend.done')}</Button>
    </Box>
  )
}
